import React from 'react';


import TodoList from './todo-list';


function TodoApp() {
  return (
    <div className="todo-app">


      <TodoList />


    </div>
  );
}


export default TodoApp;



// WEBPACK FOOTER //
// ./src/components/todo-app.js